/**
 * How the Scheduler names trackers in running text. Where Voluum and Binom
 * always showed their raw id (the provider toggles capitalise it with CSS, the
 * "could not load" line prints it as is), they keep it; Tres Commas, whose id
 * would read "tres-commas", is named by its label.
 * For Media Devoted | Created By Ciro Autiero
 */

import { matchTracker, trackerLabel, type TrackerId } from '@trafficpulse/shared';

export function trackerText(id: TrackerId): string {
  return matchTracker(id, {
    voluum: () => id,
    binom: () => id,
    'tres-commas': () => trackerLabel(id),
  });
}

/** "a", "a and b", "a, b and c" — two items read exactly as `join(' and ')`. */
export function joinWithAnd(items: readonly string[]): string {
  if (items.length <= 1) return items.join('');
  return `${items.slice(0, -1).join(', ')} and ${items[items.length - 1]}`;
}
